import dayjs from 'dayjs';

export function dateTimeUiToApi(value) {
    return dayjs(value).format('YYYY-MM-DDTHH:mm:ss');
}

export function dateTimeApiToUi(value) {
    return value ? dayjs(value).format('DD/MM/YYYY HH:mm') : '';
}
